import { getLocale } from '@/modules/locale/locale'

export default {
  methods: {
    getLocale () {
      return getLocale()
    }
  }
}
